import { Card, Cell, Image, Text } from '@vinted/web-ui'

type Props = {
  url?: string
  bottomText: string
  itemsCount?: number
}

const ItemPhoto = ({ url, bottomText, itemsCount }: Props) => {
  const renderPhoto = () => (
    <Image src={url} size="x2-large" label={itemsCount ? itemsCount.toString() : ''} alt="" />
  )

  return (
    <div className="conversation-education__item-photo--rotate">
      <Card styling="elevated">
        <div className="conversation-education__item-photo u-flexbox u-position-relative">
          {renderPhoto()}
          <div className="conversation-education__item-photo-text u-fill-width">
            <Cell theme="success" styling="tight">
              <div className="u-ui-padding-vertical-small">
                <Text
                  as="h3"
                  theme="inverse"
                  type="subtitle"
                  text={bottomText}
                  alignment="center"
                  width="parent"
                />
              </div>
            </Cell>
          </div>
        </div>
      </Card>
    </div>
  )
}

export default ItemPhoto
